(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-eb-buy-now]');
    if (!button || button.disabled) return;

    event.preventDefault();
    const form = button.closest('form');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const variantId = variantInput?.value;
    const quantity = Number(quantityInput?.value || 1);
    if (!variantId) return;

    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      if (!response.ok) throw new Error('Unable to add to bag');
      window.location.href = '/checkout';
    } catch (error) {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
